import { api } from '../../services/api';

const MATERIAL_URL = '/equipments/';

export const getData = (filters) =>
  api.get(`${MATERIAL_URL}?${filters}`);
